import { classNames } from "@/shared/utils/classnames";
import React, { FC, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import { faFileInvoice } from "@fortawesome/pro-regular-svg-icons";
import { Invoice } from "@/app/billing/invoice";
import i18n from "@/app/i18n";

export type InvoiceCardProps = {
  isLoading?: boolean;
  isDefault?: boolean;
  invoice?: Invoice;
  onDownload?: () => void;
};

export const InvoiceCard: FC<InvoiceCardProps> = ({
  isLoading,
  invoice,
  onDownload,

  isDefault,
}) => {
  const [t] = useTranslation();

  return (
    <li
      className={classNames(
        "col-span-1 flex rounded-md shadow-sm ",
        isDefault ? "ring-2 ring-primary" : ""
      )}
    >
      <div className="bg-primary flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white aspect-square">
        <FontAwesomeIcon icon={faFileInvoice} className="text-2xl" />
      </div>
      <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
        <div className="flex-1 truncate px-4 py-2 text-sm">
          {isLoading ? (
            <a className="animate-pulse bg-gray-300 w-full flex-1 flex h-4 rounded-sm mb-2"></a>
          ) : (
            <a
              className={classNames(
                "font-medium text-gray-900 hover:text-gray-600"
              )}
            >
              {invoice.number}
            </a>
          )}
          <div className="flex gap-4">
            {isLoading ? (
              <a className="animate-pulse bg-gray-300 w-2/4 flex h-4 rounded-sm"></a>
            ) : (
              <p className="text-gray-500">
                {DateTime.fromISO(invoice.createdAt)
                  .setLocale(i18n.language)
                  .toFormat("d MMMM yyyy")}
              </p>
            )}
          </div>
        </div>
        <div className="flex-shrink-0 pr-2">
          <Menu>
            <MenuButton className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
              <span className="sr-only"></span>
              <FontAwesomeIcon
                icon={faEllipsisVertical}
                aria-hidden="true"
                className="h-5 w-5"
              />
            </MenuButton>
            <MenuItems
              anchor="bottom end"
              className="absolute right-0 z-10 mt-3 w-36 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
              <MenuItem>
                <a
                  onClick={onDownload}
                  className="block px-4 py-2 text-sm text-primary-500 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                  role="button"
                >
                  Descargar
                </a>
              </MenuItem>
            </MenuItems>
          </Menu>
        </div>
      </div>
    </li>
  );
};
